import React from "react";

export function validateWorkEmail(email, t) {
  if (email.length === 0) {
    return t("request_demo_error_required_field");
  }
  const regex = /.+(@gmail.com|@yahoo.com|@hotmail.com|@outlook.com|@aol.com|@icloud.com).*$/
  if (email.match(regex)) {
    return <div dangerouslySetInnerHTML={{ __html: t("request_demo_error_provide_business_email") }}></div>;
  }

  const emailregex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!email.match(emailregex)) {
    return t("request_demo_error_email");
  }
  return null;
}
export function validateCompanyName(companyName, t) {
  if (companyName.length === 0) {
    return t("request_demo_error_required_field");
  }

  return null;
}
export function validateTeamRole(teamRole, t) {
  if (teamRole.length === 0) {
    return t("request_demo_error_required_field");
  }

  return null;
}
export function validateFullName(fullName, t) {
  if (fullName.length === 0) {
    return t("request_demo_error_required_field");
  }

  return null;
}
export function validatePhoneNumber(phoneNumber, t) {
  if (phoneNumber.length === 0) {
    return t("request_demo_error_required_field");
  }

  return null;
}

export function validateLocation(location, t) {
  if (location.length === 0) {
    return t("request_demo_error_required_field");
  }

  return null;
}
